import { render, staticRenderFns } from "./CustomCascader.vue?vue&type=template&id=489a1aa0"
import script from "./CustomCascader.vue?vue&type=script&lang=js"
export * from "./CustomCascader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1f634a4a4b1fea536ed4e950e01c2669/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports